import React from 'react'
import ModulePanel from '../../ui/ModulePanel/ModulePanel'
import './MarketingPlaceholder.sass'

function MarketingPlaceholder({ title, phase }) {
  return (
    <div className="MarketingPlaceholder">
      <ModulePanel title={title}>
        <p className="MarketingPlaceholder-Text">
          Розділ «{title}» буде реалізований у фазі {phase}. Зараз доступний лише UI таб «Посилання / UTM».
        </p>
      </ModulePanel>
    </div>
  )
}

export default MarketingPlaceholder
